'use strict'

module.exports = () => window.performance.now()
